import { formatNumberMix } from '@/utils'
import moment from 'moment'
export default {
    data() { },
    methods: {
        setCardOptions(data = {}) {
            return [
                {
                    title: this.$t('paypal::monitor::总余额'),
                    count: data && data.totalBalance ? formatNumberMix(data.totalBalance, 2, ',') : '--',
                    down: data && data.totalBalanceRatio ? data.totalBalanceRatio < 0 : false,
                    rate: data && data.totalBalanceRatio ? formatNumberMix(data.totalBalanceRatio, 2, '', '') : '--',
                    tooltip: this.$t('paypal::monitor::总余额tip'),
                    noDetail: true
                },
                {
                    title: this.$t('paypal::monitor::可提现余额'),
                    count: data && data.availableBalance ? formatNumberMix(data.availableBalance, 2, ',') : '--',
                    down: data && data.availableBalanceRatio ? data.availableBalanceRatio < 0 : false,
                    rate: data && data.availableBalanceRatio ? formatNumberMix(data.availableBalanceRatio, 2, '', '') : '--',
                    tooltip: this.$t('paypal::monitor::可提现余额tip'),
                    noDetail: true
                },
                {
                    title: this.$t('paypal::monitor::冻结余额'),
                    count: data && data.withheldBalance ? formatNumberMix(data.withheldBalance, 2, ',') : '--',
                    down: data && data.withheldBalanceRatio ? data.withheldBalanceRatio < 0 : false,
                    rate: data && data.withheldBalanceRatio ? formatNumberMix(data.withheldBalanceRatio, 2, '', '') : '--',
                    tooltip: this.$t('paypal::monitor::冻结余额tip'),
                    noDetail: true
                }
            ]
        },
        setAccountCards(data = {}) {
            return [
                {
                    title: this.$t('paypal::monitor::正常账户'),
                    num: this.$dataCheck(formatNumberMix(data.normalAccountNum, 0, '', '')),
                    unit: this.$t('paypal::monitor::个'),
                    tooltip: this.$t('paypal::monitor::正常账户tip'),
                    type: '2'
                },
                {
                    title: this.$t('paypal::monitor::不可收款账户'),
                    num: this.$dataCheck(formatNumberMix(data.nonCashAccountNum, 0, '', '')),
                    unit: this.$t('paypal::monitor::个'),
                    tooltip: this.$t('paypal::monitor::不可收款账户tip'),
                    type: '4'
                },
                {
                    title: this.$t('paypal::monitor::预警账户'),
                    num: this.$dataCheck(formatNumberMix(data.warnAccountNum, 0, '', '')),
                    unit: this.$t('paypal::monitor::个'),
                    tooltip: this.$t('paypal::monitor::触发预警规则的账户;'),
                    type: '3',
                    btnText: '设置预警规则',
                    btnFn: () => { this.$router.push({ name: 'paypal', query: { type: '2' } }) }
                },
            ]
        }
    }
}